import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button, Input, Card } from '../components/Components';
import toast from 'react-hot-toast';
import './Auth.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '', role: 'candidate' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) return toast.error('Please fill all fields');

    setLoading(true);
    try {
      const user = await login(form);
      toast.success(`Welcome back, ${user.name}!`);
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const setField = (key, val) => setForm((f) => ({ ...f, [key]: val }));

  return (
    <div className="auth-page">
      <div className="auth-page__bg">
        <div className="auth-page__orb auth-page__orb--1" />
        <div className="auth-page__orb auth-page__orb--2" />
      </div>

      <Card className="auth-card">
        <div className="auth-card__header">
          <Link to="/" className="auth-card__logo">
            <span className="auth-card__logo-icon">◉</span>
            <span className="auth-card__logo-text">CoachConnect</span>
          </Link>
          <h2 className="auth-card__title">Welcome Back</h2>
          <p className="auth-card__subtitle">Sign in to continue</p>
        </div>

        {/* Role Toggle */}
        <div className="auth-role-toggle">
          {['candidate', 'coach'].map((r) => (
            <button
              key={r}
              type="button"
              className={`auth-role-toggle__btn ${form.role === r ? 'auth-role-toggle__btn--active' : ''}`}
              onClick={() => setField('role', r)}
            >
              {r === 'candidate' ? '🎓 Candidate' : '🏆 Coach'}
            </button>
          ))}
        </div>

        <form onSubmit={handleSubmit}>
          <Input
            label="Email"
            type="email"
            value={form.email}
            onChange={(e) => setField('email', e.target.value)}
            placeholder="you@example.com"
          />
          <Input
            label="Password"
            type="password"
            value={form.password}
            onChange={(e) => setField('password', e.target.value)}
            placeholder="••••••••"
          />
          <div style={{ textAlign: 'right', marginBottom: 8 }}>
            <Link to="/forgot-password" className="auth-card__link" style={{ fontSize: 13 }}>Forgot Password?</Link>
          </div>
          <Button type="submit" fullWidth disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In →'}
          </Button>
        </form>

        <div className="auth-card__footer">
          Don't have an account? <Link to="/register" className="auth-card__link">Sign Up</Link>
        </div>

        <div className="auth-card__demo">
          <strong>Demo accounts:</strong><br />
          Coach: sarah@coach.com / pass123<br />
          Candidate: alex@user.com / pass123
        </div>
      </Card>
    </div>
  );
}
